const formatter = {
  date: (time: string | Date) =>
    new Intl.DateTimeFormat("en-US").format(new Date(time)),
  time: (time: string | Date) =>
    new Intl.DateTimeFormat("en-US").format(new Date(time)),

  shortDate: (time: string | Date) => {
    return new Date(time).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  },
  dateTime: (time: string | Date, options = {}) => {
    return new Date(time).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      ...options,
    })
  },

  number: (number: number | bigint) => new Intl.NumberFormat().format(number),
}

export default formatter
